export default __webpack_public_path__ + "img/file-jpg.1c727556.svg";